import { useCurrentSite } from '@hotjar/site';
import type { UserAttributeOptionType, UserAttributeType } from '@hotjar/global-filters';
import { GenericFilter, UserAttributeSelector } from '@hotjar/global-filters';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export interface UserAttributesChooserProps {
  userAttributeOptionList: UserAttributeOptionType[];
  userAttributeOptionIsLoading: boolean;
  onUserAttributeSelected: (newUserAttribute: UserAttributeType) => void;
}

const Container = styled.div`
  & > div[role='button'] {
    color: ${tokens.color.secondary_cta};
    background-color: transparent;
    box-shadow: inset 0 0 0 1px ${tokens.color.secondary_cta};
    height: ${tokens.spacer.x5};

    span,
    svg {
      color: ${tokens.color.secondary_cta};
      ${tokens.text('subtitle2')};
      filter: none;
    }
  }
`;

export function UserAttributesChooser({
  userAttributeOptionList,
  userAttributeOptionIsLoading,
  onUserAttributeSelected,
}: UserAttributesChooserProps): JSX.Element {
  const { data: currentSite } = useCurrentSite();
  const handleUASelected = (close: () => void, newValue?: UserAttributeType) => {
    if (newValue) {
      onUserAttributeSelected(newValue);
    }
    close();
  };

  function onAddMoreUserAttribute() {
    // Open UA settings page.
    window.open(`/settings/user-attributes?site-id=${currentSite?.id}`, '_blank');
  }

  return (
    <Container>
      <GenericFilter
        filterName="Add attribute"
        label1="Add attribute"
        iconName="plus"
        renderDropdown={({ close }) => {
          return (
            <UserAttributeSelector
              filterName="User attribute"
              userAttributeOptionList={userAttributeOptionList}
              userAttributeOptionIsLoading={userAttributeOptionIsLoading}
              onUserAttributeSelected={(newValue) => handleUASelected(close, newValue)}
              onAddMoreUserAttribute={onAddMoreUserAttribute}
            />
          );
        }}
      />
    </Container>
  );
}
